/* MIKAMI OS — windows, cart, music playlist. */
(function(){
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  function money(cents){ return '$' + (cents/100).toFixed(2).replace(/\.00$/, ''); }
  function toast(msg){ var t = $('.toast'); if(!t) return; t.textContent = msg; t.classList.add('show'); setTimeout(function(){ t.classList.remove('show'); }, 2600); }

  /* ---------- music playlist: dark ambient pieces, synthesized live ----------
     Starts on the Enter click gesture (browsers require a gesture for audio). */
  var audioCtx = null, masterGain = null, playing = false, currentTrack = 0, trackNodes = [];
  function noiseBuffer(ctx){
    var len = ctx.sampleRate * 2, buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    return buf;
  }
  function osc(ctx, type, freq, gainVal, dest){
    var o = ctx.createOscillator(); o.type = type; o.frequency.value = freq;
    var g = ctx.createGain(); g.gain.value = gainVal;
    o.connect(g); g.connect(dest); o.start(); trackNodes.push(o);
    return o;
  }
  function lfoTo(ctx, freq, amount, param){
    var l = ctx.createOscillator(); l.frequency.value = freq;
    var g = ctx.createGain(); g.gain.value = amount;
    l.connect(g); g.connect(param); l.start(); trackNodes.push(l);
  }
  var TRACKS = [
    { name: 'Night Session', build: function(ctx, out){
      var f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 320; f.Q.value = 0.8; f.connect(out);
      osc(ctx, 'sine', 55, 0.5, f); osc(ctx, 'sine', 55.6, 0.5, f); osc(ctx, 'triangle', 110.3, 0.18, f);
      lfoTo(ctx, 0.07, 120, f.frequency);
    }},
    { name: 'After Hours', build: function(ctx, out){
      var f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 480; f.Q.value = 0.6; f.connect(out);
      osc(ctx, 'sine', 65.41, 0.5, f); osc(ctx, 'sine', 98.0, 0.35, f); osc(ctx, 'triangle', 155.56, 0.15, f);
      lfoTo(ctx, 0.05, 150, f.frequency);
    }},
    { name: 'Velvet Static', build: function(ctx, out){
      var bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 500; bp.Q.value = 0.7; bp.connect(out);
      var n = ctx.createBufferSource(); n.buffer = noiseBuffer(ctx); n.loop = true;
      var g = ctx.createGain(); g.gain.value = 0.06; n.connect(g); g.connect(bp); n.start(); trackNodes.push(n);
      osc(ctx, 'sine', 49, 0.4, out);
      lfoTo(ctx, 0.11, 200, bp.frequency);
    }},
    { name: 'Empty Streets', build: function(ctx, out){
      var trem = ctx.createGain(); trem.gain.value = 0.6; trem.connect(out);
      osc(ctx, 'sine', 110, 0.4, trem); osc(ctx, 'sine', 110.7, 0.4, trem); osc(ctx, 'triangle', 220, 0.12, trem);
      lfoTo(ctx, 0.9, 0.25, trem.gain);
    }}
  ];
  function stopTrackNodes(){
    trackNodes.forEach(function(n){ try { n.stop(); } catch(e){} try { n.disconnect(); } catch(e){} });
    trackNodes = [];
  }
  function playTrack(i){
    if (!audioCtx) return;
    currentTrack = i;
    stopTrackNodes();
    var tg = audioCtx.createGain(); tg.gain.value = 1; tg.connect(masterGain);
    TRACKS[i].build(audioCtx, tg);
    syncMusicUI();
  }
  function startAudio(trackIndex){
    if (playing && audioCtx) return;
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      if (audioCtx.state === 'suspended') audioCtx.resume();
      if (!masterGain) {
        masterGain = audioCtx.createGain();
        masterGain.gain.setValueAtTime(0.0001, audioCtx.currentTime);
        masterGain.connect(audioCtx.destination);
      }
      masterGain.gain.cancelScheduledValues(audioCtx.currentTime);
      masterGain.gain.setValueAtTime(Math.max(0.0001, masterGain.gain.value), audioCtx.currentTime);
      masterGain.gain.exponentialRampToValueAtTime(0.12, audioCtx.currentTime + 2.0);
      playTrack(typeof trackIndex === 'number' ? trackIndex : 0);
      playing = true; syncMusicUI();
    } catch(e) { /* audio unavailable; desktop still works */ }
  }
  function toggleAudio(){
    if (!audioCtx) { startAudio(0); return; }
    if (playing) { masterGain.gain.linearRampToValueAtTime(0.0001, audioCtx.currentTime + 0.6); playing = false; }
    else { if (audioCtx.state === 'suspended') audioCtx.resume(); masterGain.gain.linearRampToValueAtTime(0.12, audioCtx.currentTime + 0.8); playing = true; }
    syncMusicUI();
  }
  function syncMusicUI(){
    $$('.music-state').forEach(function(el){ el.textContent = playing ? 'Playing' : 'Paused'; });
    $$('.music-dot').forEach(function(el){ el.classList.toggle('live', playing); });
    $$('.music-toggle').forEach(function(el){ el.textContent = playing ? 'Pause ambience' : 'Play ambience'; });
    $$('.track-btn').forEach(function(b){ b.classList.toggle('on', parseInt(b.dataset.track, 10) === currentTrack); });
    $$('.now-playing').forEach(function(el){ el.textContent = TRACKS[currentTrack].name; });
    var s = $('#tb-sound');
    if (s) { s.textContent = playing ? 'SOUND ON — ' + TRACKS[currentTrack].name.toUpperCase() : 'SOUND OFF'; s.classList.toggle('live', playing); }
  }
  function enterDesktop(){
    var b = $('.boot'); if (b) b.classList.add('hide');
    setTimeout(function(){ if (b) b.remove(); }, 900);
    startAudio(0);
  }
  document.addEventListener('DOMContentLoaded', function(){
    var eb = $('.boot-enter');
    if (eb) eb.addEventListener('click', enterDesktop);
    document.addEventListener('keydown', function(e){ if (e.key === 'Enter' && $('.boot')) enterDesktop(); });

    /* track list */
    var tl = $('#track-list');
    if (tl) {
      TRACKS.forEach(function(t, i){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'track-btn'; b.dataset.track = i;
        b.textContent = (i + 1) + '. ' + t.name;
        b.addEventListener('click', function(){
          if (!audioCtx) { startAudio(i); return; }
          playTrack(i);
          if (!playing) { masterGain.gain.linearRampToValueAtTime(0.12, audioCtx.currentTime + 0.8); playing = true; }
          syncMusicUI();
        });
        tl.appendChild(b);
      });
    }
    $$('.music-toggle').forEach(function(b){ b.addEventListener('click', toggleAudio); });
    $$('.music-prev').forEach(function(b){ b.addEventListener('click', function(){
      var n = (currentTrack + TRACKS.length - 1) % TRACKS.length;
      if (!audioCtx) { startAudio(n); return; }
      playTrack(n);
      if (!playing) { masterGain.gain.linearRampToValueAtTime(0.12, audioCtx.currentTime + 0.8); playing = true; }
      syncMusicUI();
    }); });
    $$('.music-next').forEach(function(b){ b.addEventListener('click', function(){
      var n = (currentTrack + 1) % TRACKS.length;
      if (!audioCtx) { startAudio(n); return; }
      playTrack(n);
      if (!playing) { masterGain.gain.linearRampToValueAtTime(0.12, audioCtx.currentTime + 0.8); playing = true; }
      syncMusicUI();
    }); });

    /* ---------- windows: open / close / minimize / drag ---------- */
    var zTop = 10;
    function openWin(id){
      var w = document.getElementById('win-' + id);
      if (!w) return;
      w.classList.remove('closed', 'minimized');
      w.style.zIndex = ++zTop;
      syncTaskbar();
      if (window.innerWidth <= 760) {
        setTimeout(function(){ w.scrollIntoView({ block: 'start' }); window.scrollBy(0, -64); }, 50);
      } else {
        w.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
    function syncTaskbar(){
      $$('.taskbar .tb-btn[data-win]').forEach(function(b){
        var w = document.getElementById('win-' + b.dataset.win);
        b.classList.toggle('on', !!(w && !w.classList.contains('closed') && !w.classList.contains('minimized')));
      });
    }
    function activateTab(tabId){
      $$('.tabs button').forEach(function(x){ x.classList.toggle('on', x.dataset.tab === tabId); });
      $$('.tabpane').forEach(function(p){ p.classList.toggle('on', p.id === tabId); });
      if (tabId === 'tab-archive') renderArchive();
    }
    $$('.icon[data-win]').forEach(function(el){
      el.addEventListener('click', function(){
        openWin(el.dataset.win);
        if (el.dataset.tab) activateTab(el.dataset.tab);
      });
    });
    $$('.taskbar .tb-btn[data-win]').forEach(function(el){
      el.addEventListener('click', function(){ openWin(el.dataset.win); });
    });
    $$('.win .win-close').forEach(function(b){
      b.addEventListener('click', function(){ b.closest('.win').classList.add('closed'); syncTaskbar(); });
    });
    $$('.win .win-min').forEach(function(b){
      b.addEventListener('click', function(){ b.closest('.win').classList.add('minimized'); syncTaskbar(); });
    });
    if (window.matchMedia('(min-width: 761px)').matches) {
      $$('.win').forEach(function(w){
        var head = $('.win-head', w); if (!head) return;
        var dx = 0, dy = 0, sx = 0, sy = 0, dragging = false;
        head.addEventListener('pointerdown', function(e){
          dragging = true; sx = e.clientX; sy = e.clientY;
          var r = w.getBoundingClientRect();
          dx = sx - r.left; dy = sy - r.top;
          w.style.position = 'fixed'; w.style.left = r.left + 'px'; w.style.top = r.top + 'px';
          w.style.margin = '0'; w.style.maxWidth = r.width + 'px'; w.style.width = r.width + 'px';
          w.style.zIndex = ++zTop;
        });
        document.addEventListener('pointermove', function(e){
          if (!dragging) return;
          w.style.left = Math.max(0, Math.min(window.innerWidth - 80, e.clientX - dx)) + 'px';
          w.style.top = Math.max(54, Math.min(window.innerHeight - 60, e.clientY - dy)) + 'px';
        });
        document.addEventListener('pointerup', function(){ dragging = false; });
      });
    }

    /* ---------- shop tabs ---------- */
    $$('.tabs button').forEach(function(b){
      b.addEventListener('click', function(){ activateTab(b.dataset.tab); });
    });

    /* ---------- cart ---------- */
    function refreshBag(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        var count = cart.item_count;
        $$('.bag-count').forEach(function(el){ el.textContent = count; });
        var box = $('#bag-items');
        if (box) {
          if (!cart.items.length) {
            box.innerHTML = '<p class="empty">Nothing in the dark yet.</p>';
          } else {
            box.innerHTML = cart.items.map(function(it){
              return '<div class="bag-item"><span class="bag-ph"><img src="' + (it.image || '') + '" alt=""></span><div class="bi"><div class="t">' + it.product_title + '</div><div class="v">' + it.variant_title + ' × ' + it.quantity + ' — ' + money(it.line_price) + '</div></div><button class="rm" data-key="' + it.key + '">Remove</button></div>';
            }).join('');
            $$('.rm', box).forEach(function(b){
              b.addEventListener('click', function(){
                fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) }).then(refreshBag);
              });
            });
          }
        }
        var st = $('#bag-subtotal'); if (st) st.textContent = money(cart.total_price);
      });
    }
    function addToBag(variantId){
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
        .then(function(r){ if (!r.ok) throw new Error('unavailable'); return r.json(); })
        .then(function(){ refreshBag(); toast('Added to bag'); openWin('bag'); })
        .catch(function(){ toast('That size is unavailable'); });
    }
    document.addEventListener('click', function(e){
      var add = e.target.closest('.add');
      if (add) {
        var sel = add.parentElement.querySelector('select');
        var vid = sel ? sel.value : add.dataset.variant;
        if (vid) addToBag(vid);
      }
      var add2 = e.target.closest('.add2');
      if (add2) {
        var sel2 = document.getElementById('prod-variant');
        if (sel2 && sel2.value) addToBag(sel2.value);
      }
    });
    $$('.bag-open').forEach(function(b){ b.addEventListener('click', function(){ openWin('bag'); }); });

    /* ---------- archive via storefront JSON (all active products) ----------
       Rendered on first Archive tab click (not at page load): the tab pane is
       display:none until then, and lazy images created inside a hidden pane
       never reliably load. Images are eager here, and the title links to the
       product page like the photo does. ---------- */
    var arch = $('#archive-grid');
    function renderArchive(){
      if (!arch || arch.dataset.loaded) return;
      arch.dataset.loaded = '1';
      fetch('/collections/archive-resale/products.json?limit=250').then(function(r){ return r.json(); }).then(function(data){
        var items = (data.products || []).filter(function(p){ return p.variants.some(function(v){ return v.available; }); });
        if (!items.length) { arch.innerHTML = '<p class="empty">Archive loading failed — open the Archive collection instead.</p>'; return; }
        var ap = $('#archive-path');
        if (ap) ap.textContent = 'C:\\MIKAMI\\ARCHIVE — ' + items.length + ' OBJECTS';
        arch.innerHTML = items.map(function(p){
          var avail = p.variants.filter(function(v){ return v.available; });
          var first = avail[0];
          var img = (p.images && p.images[0]) ? p.images[0].src : '';
          var img2 = (p.images && p.images[1]) ? p.images[1].src : '';
          var opts = avail.map(function(v){ return '<option value="' + v.id + '">' + (v.title === 'Default Title' ? 'One size' : v.title) + ' — $' + parseFloat(v.price).toFixed(2) + '</option>'; }).join('');
          var sel = '<select>' + opts + '</select>';
          var imgtag = img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '') + '"' + (img2 ? ' onerror="this.onerror=null;this.src=\'' + img2 + '\';"' : '') + '>' : '';
          var url = '/products/' + p.handle;
          return '<article class="card"><a class="ph" href="' + url + '">' + imgtag + '</a><div class="meta"><div class="t"><a href="' + url + '">' + p.title + '</a></div><div class="p">$' + parseFloat(first.price).toFixed(2) + '</div></div><div class="buy">' + sel + '<button class="add">Add</button></div></article>';
        }).join('');
      }).catch(function(){ arch.innerHTML = '<p class="empty">Archive unavailable right now.</p>'; });
    }
    $$('.tabs button[data-tab="tab-archive"]').forEach(function(b){ b.addEventListener('click', renderArchive); });

    /* ---------- clock ---------- */
    function clock(){
      var el = $('.tb-clock'); if (!el) return;
      var d = new Date();
      el.textContent = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    clock(); setInterval(clock, 30000);
    refreshBag(); syncTaskbar();
  });
})();
